<template>
    <div></div>
</template>
<script>
import i18n from '@/i18n';
import axios from "axios";
import { HomeIcon } from "@heroicons/vue/outline";

import { mapActions } from "vuex";
import {
  //BellIcon,

  LibraryIcon,
  UserGroupIcon,

  MapIcon
} from "@heroicons/vue/outline";
export default {
  name: "SideBarDesktopCliente",
  emits: [
     "chgFaenaCentros",
     "chgIdPantalla",
     "chgIdPantalla2",
     "handleDropFaena",
     "loadModalUsuarios",
    "loadModalServiceUnavailable",
    "loadFormCambiaPass"
  ],
  data(){
   return{
    seleccion:{
      historial:0,
      live:0,
      resumen:false
    },
    secondaryNavigation: [
      
        {  name:  i18n.global.t('cerrarsesion'), href: "/logout"  },
      ]
    }
  },
  props: {
    navigation: {
      type: Object,
    },
   
     
    faenas: {
      type: Array,
    },
  },
  watch: {
    faenas: function (f) {
      let obj = [];
      let pos = 0;
      f.forEach((objeto) => {
        pos++;
        obj.push({
          id: objeto.id,
          nombre: objeto.nombre,
          tipo: objeto.tipo,
          consumo_o2: objeto.consumo_o2,
          pos: pos
        });
      });
      // descomentar 
      //  this.$store.dispatch("draggableCreate", obj);
    },
  },
  components() {
  HomeIcon,
  LibraryIcon,
  UserGroupIcon,
  MapIcon
  },
  methods: {
    ...mapActions("draggdropp", ["draggableCreate", " setIdCurrentDrag"]),
   async  showModalUsuario(){
      let cod = await this.chkPermisos();
      //console.log( 'cod', cod );
      if (cod == 401){
        this.$emit("loadModalErrorAcceso", true);
      }else{
        if (cod == 200){
          this.$emit("loadModalUsuarios", true);
        }else{
         
          this.$emit("loadModalServiceUnavailable", true);
        }  
      }   
    },
    async chkPermisos() {
      try {
        const apiKey = this.$store.state.login.tokenLogin;

        const data = {};
        const url = "/api/admin/getUsers";
        const resp = await axios.post(url, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${apiKey}`,
          },
        });
        if (resp.status === 200) 
        {
         
          
            return  resp.data.status; 
             
         
        }
        return 0;

      } catch (err) {
        //console.log(err.response) ;         
      }  
    },
    showModalConfiguracion(){
       //console.log('configuracion');
    },
    loadCentros(f) {
      this.seleccion.live = f.id;
      this.seleccion.historial = 0;
      this.seleccion.resumen = false;
      //console.log("carga centros de Faena ", f);
      this.$emit("chgFaenaCentros", f);
      this.$store.state.gotolive= true;
      // this.$emit("chgCentros", f);
    },
    loadHistorial(f) {
      //console.log("historial ", f.id);
      this.seleccion.historial = f.id;
      this.seleccion.live = 0;
      this.seleccion.resumen = false;
      this.$emit("loadHistorial", f);
    },
    ExitCodAccion(id) {
      // //console.log("chgIdPantalla2 ", 1);
      this.seleccion.historial = 0;
      this.seleccion.live = 0;
      this.seleccion.resumen = true;
      this.$emit("chgIdPantalla", { id: id});
    },
    handleDragOVer(event) {
      //console.log("over");
      event.preventDefault();
    },
    handleDrop(id) {
      //console.log("DROP en Faena LATERAL", id);
      this.$store.dispatch("setPosCurrentDroppable", id);
      this.$emit("handleDropFaena");
    },
    loadFormCambiaPass(){
        //console.log('cambiar pass')
        this.$emit("loadFormCambiaPass");
    },
    handleDrag(id) {
      //console.log('tomando ', id)
      this.$store.dispatch("setIdCurrentDrag", id);
    },
    handleDragFaena(id) {
      //console.log("tomando faena ", id);
      this.$store.dispatch("setIdCurrentDroppable", id);
      this.isDragStart = true;
    },
    handleDragEnd() {
      //console.log('fin del drag');
      this.$store.dispatch("setIdCurrentDrag", '');
    },
      loadMapa() {
      //console.log("mapa" );
      this.$emit("loadMapa");
    },
    loadLayout(idFaena) {
      //console.log("layout");
      this.$emit("loadLayout",idFaena);
    },
  },
  mounted(){
    this.seleccion.resumen = true;
  }
};
</script>
